/**
 * @name getViewportHeight
 *
 * @description Returns the current viewport height in pixels
 *
 * @example
 * import { getViewportHeight } from '@workbench/core';
 *
 * getViewportHeight(); // 768
 */
export function getViewportHeight(): number {
  return Math.max(window.document.documentElement.clientHeight || 0, window.innerHeight || 0);
}
